export const SKIP_TO_CONTENT_ANCHOR_KEY = "data-skip-content-anchor"
export const MAIN_NAV_CHILD_ANCHOR_KEY = "main-nav-child-anchor"

export const MAX_INT_32: number = 2147483647
// Contact information
export const AFFILIATE_SUPPORT_EMAIL = "affiliatesupport@healthadvocate.com"
